import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const houseCall = createAsyncThunk('anyRequests/houseCall', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.houseCall(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
